export const USD = 'USD';
export const EUR = 'EUR';
export const GBP = 'GBP';
export const AUD = 'AUD';
export const JPY = 'JPY';
export const SGD = 'SGD';
export const COP = 'COP';
export const CAD = 'CAD';
export const INR = 'INR';